import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { BaseResponse } from "../models/base.response";
import { Observable } from "rxjs";
import { Appointment } from "../models/appointment.model";

@Injectable({
    providedIn: "root",
})
export class AppointmentsService {
    constructor(private http: HttpClient) { }

    findByCustomer(userId: string): Observable<BaseResponse<Appointment[]>> {
        let params = new HttpParams().set('customerId', userId);
        return this.http.get<BaseResponse<Appointment[]>>(`${environment.apiUrl}/appointments`, { params })
    }

    findByCoach(coachId: string): Observable<BaseResponse<Appointment[]>> {
        let params = new HttpParams().set('coachId', coachId);
        return this.http.get<BaseResponse<Appointment[]>>(`${environment.apiUrl}/appointments`, { params })
    }

    findById(id: string): Observable<BaseResponse<Appointment>> {
        return this.http.get<BaseResponse<Appointment>>(`${environment.apiUrl}/appointments/${id}`)
    }

    delete(id: string): Observable<any> {
        return this.http.delete(`${environment.apiUrl}/appointments/${id}`)
    }

    updateNotes(id: string, notes: string): Observable<any> {
        return this.http.put(`${environment.apiUrl}/appointments/${id}/notes`, { notes })
    }

    updateFiles(id: string, files: Array<{
        name: string;
        size: number;
        type: string;
        url: string;
        uploadDate: Date;
    }>): Observable<any> {
        return this.http.put(`${environment.apiUrl}/appointments/${id}/files`, { files })
    }

    updateNotesAndFiles(id: string, notes: string, files: Array<{
        name: string;
        size: number;
        type: string;
        url: string;
        uploadDate: Date;
    }>): Observable<any> {
        return this.http.put(`${environment.apiUrl}/appointments/${id}/notes-and-files`, { notes, files })
    }
}